module.exports = __webpack_public_path__ + "img/stock6.0830a9f9.png";